import React from "react";
import { motion } from "framer-motion";

interface ProgressIndicatorProps {
  totalSteps: number;
  currentStep: number;
}

const ProgressIndicator: React.FC<ProgressIndicatorProps> = ({
  totalSteps,
  currentStep,
}) => {
  return (
    <div className="flex items-center justify-center gap-[10px]">
      {Array.from({ length: totalSteps }, (_, index) => {
        const stepNumber = index + 1;
        const isActive = stepNumber === currentStep;
        return (
          <motion.div
            key={stepNumber}
            className={`rounded-full ${isActive ? "bg-[#00E0FF]" : "bg-white"}`}
            initial={false}
            animate={{
              width: isActive ? 12 : 6,
              height: isActive ? 12 : 6,
            }}
            transition={{
              type: "spring",
              stiffness: 300,
              damping: 30,
              duration: 0.3,
            }}
          />
        );
      })}
    </div>
  );
};

export default ProgressIndicator;
